import {Component, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {ApiService} from '../../../services/api.service';
import { AuthenticationService } from '../../../services/authentication.service';
import {DepartmentListDetailComponent} from '../department-list-detail/department-list-detail.component';
// import * as _ from 'lodash';
import { finalize } from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';
import {Subscription} from "rxjs";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Department } from '../department.model';

@Component({
  selector: 'department-list',
  templateUrl: './department-list.component.html',
  styleUrls: ['./department-list.component.scss'],
})
export class DepartmentListComponent implements OnInit, OnDestroy {
  itemsPerPage = 40;
  modal = null;
  modalData = null;
  searchDepartmentID: any = '';
  searchDepartmentName: any = '';
  groups: any = [];
  totalItems: number;
  currentPage = 1;
  loading = false;
  list: any = [];
  subs: Subscription;

  departmentDetails = [];
  test = [];

  @ViewChild('detailModal') detailModal: DepartmentListDetailComponent;
  @ViewChild('deleteConfirmation') deleteConfirmationModal: TemplateRef<any>;

  constructor(
    private apiService: ApiService,
    private translate: TranslateService,
    private authService: AuthenticationService,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.subs = this.translate.onLangChange.subscribe((res: string) => {
      this.loadData();
    });
    this.loadData();
  }

  reload() {
    this.pageChanged();
  }

  pageChanged() {
    this.loadData();
  }

  optionChanged() {
    this.search();
  }

  openModal(data?: Department, index?: number) {
    this.detailModal.open(this, data);
  }

  search() {
    this.currentPage = 1;
    this.loadData();
  }

  loadData() {
    this.loading = true;
    const data = {
      page: this.currentPage,
      items_per_page: this.itemsPerPage,
      code: this.searchDepartmentID || '',
      name: this.searchDepartmentName || '',
    };
    this.apiService.getDepartments(data)
      .pipe(
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe(
        (response: any) => {
          this.departmentDetails = response.results;
          this.totalItems = response.count;
        }
      );
  }

  revertBack(): void {
    this.modal.close();
    this.modal = null;
    this.modalData = null;
  }

  sniff(action, target) {
    const data = {
      action: action,
      address: 'MANAGE_DEPARTMENT',
      target: target
    };
    this.apiService.sniff(data).subscribe(
      (res: any) => {
      },
    );
  }

  confirmDelete(index): void {
    this.modalData = this.departmentDetails[index];
    this.modal = this.modalService.open(this.deleteConfirmationModal, {backdrop: 'static', centered: true})
  }

  confirmedDelete(productId: number): void {
    this.apiService.deleteDepartment(productId).subscribe(
      () => {
        this.loadData();
        this.sniff('DELETE_DEPARTMENT', this.modalData.name_en)
        this.revertBack();
      });
  }

  clearSearch() {
    this.searchDepartmentID = '';
    this.searchDepartmentName = '';
    this.loadData()
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
  get isAdmin(): boolean {
    return this.authService.isAdmin();
  }
  get isIT(): boolean {
    return this.authService.isIT();
  }
  get isAccountant(): boolean {
    return this.authService.isAccountant();
  }
  get isAccountantAdmin(): boolean {
    return this.authService.isAccountantAdmin();
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/department/department-list/department-list.component.ts